import React from "react";
import Content from "../components/Content";
const Home:React.FC = () => {
  return (
    <>
      <Content  />
    </>
  );
};

export default Home;
